<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="aggiornaForm">

	<form [formGroup]="aggiornaForm" (ngSubmit)="update();">
		<div class="row">

			<div comboModInput [control]="aggiornaForm.controls['tipoEsito']" class="col-sm-4 obbligatorio"
				[labelInput]="'Tipo'" formControlName="tipoEsito" [mandatory]="true"
				[objectReference]="request.tipoEsito" (onReturn)="request.tipoEsito = $event;"
				[optionsCombo]="tipoEsitiOptions" [ngModel]="request.tipoEsito"></div>

			<div comboModInput [control]="aggiornaForm.controls['esitoPerSocieta']" class="col-sm-4 obbligatorio"
				[labelInput]="'Esito'" formControlName="esitoPerSocieta" [mandatory]="true" [submitPending]="!request.tipoEsito"
				[objectReference]="request.esitoPerSocieta" (onReturn)="request.esitoPerSocieta = $event"
				[optionsCombo]="esitiPerSocietaOptions" [ngModel]="request.esitoPerSocieta"></div>

			<div checkBoxRadio class="col-sm-4" [labelInput]="'Definitivo'" idInput="definitivo_{{request.id}}"
				formControlName="definitivo" [objectReference]="request.definitivo" [control]="aggiornaForm.controls['definitivo']"
				(onReturn)="request.definitivo = $event"></div>

		</div>
		<div class="row">

			<div textInput [control]="aggiornaForm.controls['numeroProtocollo']"
				class="col-sm-4" [labelInput]="'N. protocollo '"
				formControlName="numeroProtocollo" [(ngModel)]="request.numeroProtocollo"></div>

			<div textInput [control]="aggiornaForm.controls['numeroEsito']" [mandatory]="true" class="col-sm-4"
				[labelInput]="'Numero esito'" formControlName="numeroEsito" [(ngModel)]="request.numeroEsito"></div>

			<div naturalNumberInput [control]="aggiornaForm.controls['annoEsito']" class="col-sm-4"
				[labelInput]="'Anno esito'" [maxLength]="'4'" formControlName="annoEsito" [checkFormat]="true"
				[(ngModel)]="request.annoEsito" [mandatory]="true"></div>

			<!-- <div comboModInput [control]="aggiornaForm.controls['societa']"
			class="col-sm-3"
			[labelInput]="'Societ&agrave;'"
			formControlName="societa"
			[objectReference]="request.societa"
			[submitPending]="request.liquidati && request.liquidati.length > 0"
			[mandatory]="true"
			(onReturn)="request.societa = $event"
			[optionsCombo] ="societaOptions"
			[labelOption]="'descrizione'"
			[(ngModel)]="request.societa">
		</div> -->


		</div>
		<div class="row">
    		<div datePickerInput class="col-sm-4" [labelInput]="'Data pronuncia'" formControlName="dataPronuncia"
				[(ngModel)]="request.dataPronuncia"></div>

			<div datePickerInput class="col-sm-4" [labelInput]="'Data deposito'" formControlName="dataDeposito"
				[(ngModel)]="request.dataDeposito" [control]="aggiornaForm.controls['dataDeposito']">
			</div>

			<div datePickerInput class="col-sm-4" [labelInput]="'Data pubblicazione'"
				formControlName="dataPubblicazione" [(ngModel)]="request.dataPubblicazione" [mandatory]="fascicolo?.praticaBase?.tipoPratica?.descrizione != 'PENALE'"></div>

		</div>
		<hr style="visibility: hidden;">
		<div class="row">
      <div datePickerInput class="col-sm-4" [labelInput]="'Data comunicazione'" formControlName="dataComunicazione"
           [(ngModel)]="request.dataComunicazione" [mandatory]="false"></div>

      <div datePickerInput class="col-sm-4" [labelInput]="'Data notifica'" formControlName="dataNotifica"
				[(ngModel)]="request.dataNotifica"></div>

			<div datePickerInput class="col-sm-4" [labelInput]="'Data trasmissione sentenza'" formControlName="dataTrasmissioneSentenza"
				[(ngModel)]="request.dataTrasmissioneSentenza"></div>

		</div>
    <hr style="visibility: hidden;">
    <div class="row">
      <div datePickerInput class="col-sm-4" [labelInput]="'Data impugnazione'" formControlName="dataImpugnazione"
           [(ngModel)]="request.dataImpugnazione"></div>

      <div datePickerInput class="col-sm-4" [labelInput]="'Data irrevocabilità'" formControlName="dataIrrevocabilita"
           [(ngModel)]="request.dataIrrevocabilita"></div>
    </div>

		<hr style="visibility: hidden;">
		<div class="row">
		<div checkBoxRadio class="col-sm-4" [labelInput]="'Condanna in solido'" idInput="condannaInSolido_{{request.id}}"
			formControlName="flagCondannaInSolido" [objectReference]="request.flagCondannaInSolido" [control]="aggiornaForm.controls['flagCondannaInSolido']"
			(onReturn)="request.flagCondannaInSolido = $event">
		</div>
      	<div checkBoxRadio class="col-sm-4" [labelInput]="'Rivalsa'" idInput="rivalsa_{{request.id}}"
			formControlName="flagRivalsa" [objectReference]="request.flagRivalsa" [control]="aggiornaForm.controls['flagRivalsa']"
			(onReturn)="request.flagRivalsa = $event"></div>
		</div>

		<div class="row">
			<div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note"
				[(ngModel)]="request.note"></div>
		</div>

		<div class="row">
			<p class="mandatory col-sm-12">
				<em>* Campi obbligatori</em>
			</p>
		</div>
		<div class="row">
			<p class="col-sm-3 col-xs-6">
				<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
			</p>
			<p submitButton [disabled]="!aggiornaForm.valid" class="col-sm-3 col-xs-6 col-sm-offset-6"
				[labelButton]="'Inserisci e salva'"></p>
		</div>
	</form>
</ng-template>
